import { c as _c } from "react/compiler-runtime";
import { DonationDialog } from "modules/promos/components/DonationDialog";
import { StickyPopup } from "modules/promos/components/StickyPopup";
import { PlacementEngineEvent } from "modules/promos/contexts/PromosContext";
import { PromosTheme, PromoThemeName } from "modules/promos/contexts/PromosTheme";
import { PromoDataProps, PromoTypes } from "modules/promos/types";
import { EffectFn1 } from "common/lib/types";
export interface CreativeProps {
  promo: PromoDataProps;
  events: {
    onClick: PlacementEngineEvent;
    onClose: PlacementEngineEvent;
  };
  // ref type from `react-intersection-observer`
  creativeRef: EffectFn1<Element | null>;
}

/**
 * Factory like component, that renders the promo creative based on the given promo data type.
 */
export const Creative = t0 => {
  "use memo";

  const $ = _c(11);
  const {
    promo,
    events,
    creativeRef
  } = t0;
  const theme = promo.data?.theme || PromoThemeName.Default;
  let t1;
  if ($[0] !== creativeRef || $[1] !== events || $[2] !== promo.data) {
    t1 = {
      ...promo.data,
      ...events,
      creativeRef
    };
    $[0] = creativeRef;
    $[1] = events;
    $[2] = promo.data;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const creativeProps = t1;
  switch (promo.type) {
    case PromoTypes.DonationDialog:
      {
        let t2;
        if ($[4] !== creativeProps) {
          t2 = <DonationDialog {...creativeProps} />;
          $[4] = creativeProps;
          $[5] = t2;
        } else {
          t2 = $[5];
        }
        return t2;
      }
    case PromoTypes.StickyPopup:
      {
        let t2;
        if ($[6] !== creativeProps) {
          t2 = <StickyPopup {...creativeProps} />;
          $[6] = creativeProps;
          $[7] = t2;
        } else {
          t2 = $[7];
        }
        let t3;
        if ($[8] !== t2 || $[9] !== theme) {
          t3 = <PromosTheme name={theme}>{t2}</PromosTheme>;
          $[8] = t2;
          $[9] = theme;
          $[10] = t3;
        } else {
          t3 = $[10];
        }
        return t3;
      }
    default:
      {
        return null;
      }
  }
};